
import { useCallback } from 'react';
import { hapticFeedback } from '../utils/haptics';

export function useHaptics() {
  const trigger = useCallback((type: keyof typeof hapticFeedback = 'light') => {
    hapticFeedback[type]();
  }, []);

  return trigger;
}
